<template>
  <v-container fluid>
    <avs-card class="pb-4">
      <template v-slot:title>
        <v-toolbar
          class="mt-4 custom-toolbar"
          elevation="0"
        >
          <v-text-field
            clearable
            hide-details
            prepend-inner-icon="mdi-magnify"
            :label="$t('commons.search')"
            v-model="search"
          />
        </v-toolbar>
      </template>

      <template v-slot:content>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="users"
          loading-text="Loading pending invitations..."
          no-data-text="$t('messages.information.no_data')"
          class="ma-10"
          :search="search"
          hide-default-footer
        >
          <template v-slot:item.user_role="{ item }">
            <avs-role :role="item.user_role ? item.user_role : $t('commons.not_role_yet')" />
          </template>

          <template v-slot:item.resend="{ item }">
            <v-btn
              @click="inviteUser(item)"
              color="primary"
              fab
              text
            >
              <v-icon>mdi-email</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
    </avs-card>
  </v-container>
</template>

<script>
import AdminServices from "@/services/AdminServices"
import { toDatetime } from "@/utils/datetime"
import { PROJECT_MEMBER_ROLES } from "@/utils/consts"

export default {
  name: "AdministrationUsersPending",
  data() {
    return {
      headers: [
        { text: "Name", align: "start", sortable: true, value: "invitee_identifier" },
        { text: "Role", align: "center", value: "user_role" },
        { text: "Resend invitation", align: "center", value: "resend" }
      ],
      dialogActivation: false,
      deleteDialogIsOpen: false,
      users: [],
      loading: false,
      search: "",
      companyId: null,
      companyName: null,
      selectedAccount: {},
      editable: false,
      chosenUser: {
        is_active: true
      },
      roleItems: PROJECT_MEMBER_ROLES
    }
  },
  methods: {
    toDatetime,
    inviteUser(item) {
      let res = null
      if (item.user_role === "inspector") {
        res = [
          {
            privileges: {
              inspector: true,
              operator: false
            },
            email: item.invitee_identifier
          }
        ]
      } else if (item.user_role === "operator") {
        res = [
          {
            privileges: {
              inspector: false,
              operator: true
            },
            email: item.invitee_identifier
          }
        ]
      }
      AdminServices.inviteMember(this, this.companyId, res).then(response => {
        this.$store.commit("app/message", {
          msg: "invite(s) sent",
          color: "success"
        })
      })
    }
  },

  mounted() {
    this.loading = true
    this.companyId = this.$store.getters["app/getCompany"].pk
    this.companyName = this.$store.getters["app/getCompany"].name
    AdminServices.getPendingInvitations(this, this.companyId)
      .then(r => {
        this.users = r.results
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
